import { Text } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IDropZonePlaceholderProps = IContainerProps & {
  children: React.ReactNode;
};

const styles = stylex.create({
  host: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingTop: '1.25rem',
    paddingBottom: '1.25rem',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    textAlign: 'center',
  },
});

export const DropZonePlaceholder: React.FC<IDropZonePlaceholderProps> = ({
  sx,
  children,
}) => (
  <Text variant="label" size="lg" sx={[styles.host, sx]}>
    {children}
  </Text>
);
